import {DataSource} from "@/datasources/consulte-grid";
import {PatTipoBemModel} from '@/models/patrimonio/pattipobem/pattipobem.model';
import PatTipoBemService from "@/services/patrimonio/pattipobem/pattipobem.service";

export default class PatTipoBemDataSource extends DataSource<PatTipoBemModel> {
 constructor(pageNumber: number, rowsPerPage: number, rowsPageCount: number, totalRowCount: number, Rows: PatTipoBemModel[], onLoad?: (rows: any) => void) {
  super(pageNumber, rowsPerPage, rowsPageCount, totalRowCount, new Array<PatTipoBemModel>())
  if (onLoad)
   this.setOnLoad(onLoad);
 }

 async load() : Promise<any> {
  const result = ((await PatTipoBemService.dadosIndexPaginado(this.pageNumber, this.rowsPerPage, this.filters)).data as any) as DataSource<PatTipoBemModel>;
  this.pageNumber = result.pageNumber;
  this.rowsPageCount = result.rowsPageCount;
  this.rowsPerPage = result.rowsPerPage;
  this.rows = result.rows;
  this.sortDataField = result.sortDataField;
  this.sortOrder = result.sortOrder;
  this.totalRowCount = result.totalRowCount;
  this.filters = result.filters;
  return super.load();
 }
}
